module.exports = __webpack_public_path__ + "01_mustache_grey.2ebe6a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/01_mustache_grey.png
// module id = xogM
// module chunks = 0